import React, {Component} from 'react';
import _ from 'lodash';
import {safeMult, createUUID, getExtension} from 'common/utils';
import { ACCEPTED_FILE_TYPES} from 'app-ui-componentlibrary/dist/common/constants';
import UploadView from './UploadView';

const presentationalNameMap = {
  basic: UploadView,
};

export const sizeError = (size, is1GbAttachmentAccepted) => {
  if (!is1GbAttachmentAccepted) {
    return `Your file is too large. Files must be less than ${size}MB.`;
  } else {
    return `The file size must be less than or equal to 1 GB.`;
  }
};

export const sizeZeroError = () => {
  return `Your file is too small. Files must be greater than 0mb.`;
};

export const extensionError = (acceptedFileTypes) =>
  `Your file extension is invalid. Files must be one of: ${acceptedFileTypes.join(
    ", "
  )}.`;

export class FileUploadController extends Component {
  constructor(props) {
    super(props);
    const {acceptedFileTypes} = this.props;
    this.state = {
      filesSuccessful: [],
      filesFailed: [],
      isSupportedFile: null,
      saving: false,
      errorMessages: '',
      attachmentError: [],
      acceptedFileTypes: acceptedFileTypes || [],
    };
  }
 
  /** DEFAULT PROPS that match current backend requirements **/
  static defaultProps = {
    acceptedFileTypes: ACCEPTED_FILE_TYPES,
    chooseMulti: false,
  };

  processFile(file, errorMsg) { 
    let result = {
      fileName: file.fileName,
      submissionId: file.submissionId,
      error: '',
    };
    if (!_.isEmpty(errorMsg)) { 
      result.error = errorMsg;
    }
    return result;
  }

  handleUpload = (file) => {
    const {
      attachmentType,
      acceptedFileTypes,
      is1GbAttachmentAccepted,
      avoid1GbAttachmentSaveError,
      avoid0MbAttachmentSaveError,
    } = this.props;

    let isFailed = false;
    let toUpload = [];
    let errorMsg = '';
    let errorList = this.state.attachmentError;
    let fileName = file.name;
    let attachmentExtension = '.' + getExtension(fileName);
    let fileSizeLmtInBytes = safeMult(1, 1048576); // Converting to Bytes

    let fileAttrs = {
      submissionId: createUUID(),
      file,
      fileName,
    };

    if (!acceptedFileTypes.includes(attachmentExtension.toLowerCase())) {
      isFailed = true;
      errorMsg = extensionError(acceptedFileTypes);
      this.processFile(fileAttrs, extensionError(acceptedFileTypes));
      errorList.push(extensionError(acceptedFileTypes));
      if (avoid1GbAttachmentSaveError === null) {
        this.props.saveDataErrors('attachmentError', errorList);
      }
    } else if (file.size > fileSizeLmtInBytes) {
      isFailed = true;
      errorMsg = sizeError(1, is1GbAttachmentAccepted);
      this.processFile(fileAttrs, sizeError(1, is1GbAttachmentAccepted));
      errorList.push(sizeError(1, is1GbAttachmentAccepted));
      if (avoid1GbAttachmentSaveError === null) {
        this.props.saveDataErrors('attachmentError', errorList);
      }
    } else if (file.size == 0) {
      isFailed = true;
      errorMsg = sizeZeroError();
      this.processFile(fileAttrs, sizeZeroError());
      errorList.push(sizeZeroError());
      if (avoid0MbAttachmentSaveError === null) {
        this.props.saveDataErrors('attachmentError', errorList);
      }
    } else {
      toUpload.push(fileAttrs);
    }

    this.setState({
      attachmentError: errorList,
    });

    let processedToUpload = this.processFile(fileAttrs, errorMsg);

    if (isFailed) {
        this.setState({
            ...this.state,
            filesFailed: processedToUpload,
          });          
    } else {      
      this.setState({
        saving: true,
        filesSuccessful: file,
        attachmentError: [],
      });      
    }
    this.props.uploadAttachment(isFailed, toUpload);
  };

  render() {
    const {filesSuccessful, filesFailed, saving, attachmentError} = this.state;
    let {
      attachmentType,
      acceptedFileTypes,
      displayFormat,
      header,
      showAcceptedFileTypes,
    } = this.props;

    let Presentational = '';
    Presentational = presentationalNameMap[displayFormat] || UploadView;

    const propsToPass = {
      handleChange: this.handleUpload,
      disabled: saving,
      filesSuccessful,
      filesFailed,
      attachmentType, 
      acceptedFileTypes,
      errorMessages: attachmentError,
      header,
      showAcceptedFileTypes,
    };

    return <Presentational {...propsToPass} />;
  }
}

export default FileUploadController;
